import { BlockedValueModalTranslations } from "./blocked-value-modal-pt-br";

export const BLOCKED_VALUE_MODAL_FR_FR: BlockedValueModalTranslations = {
	title: "Valeur Bloquée",
	description: "Que sont les valeurs bloquées?",
	descriptionText: [
		"Les valeurs bloquées sont des montants temporairement indisponibles",
		"en raison de politiques de sécurité ou de traitement des transactions.",
	].join(" "),
	totalSummary: "Somme Totale",
	liquidationDate: "DATE DE LIQUIDATION",
	competenceDate: "DATE DE COMPÉTENCE",
	type: "TYPE",
	category: "CATÉGORIE",
	observation: "OBSERVATION",
	value: "VALEUR",
	blockTypes: {
		"Bloqueio automático": "Blocage automatique",
		"Bloqueio manual": "Blocage manuel",
		"Cessão de recebíveis": "Cession de créances",
	},
	blockCategories: {
		"Transferência de titularidade": "Transfert de propriété",
		"Ônus - Cessão fiduciária": "Charges - Cession fiduciaire",
		"Ônus - Outros": "Charges - Autres",
		"Bloqueio judicial": "Blocage judiciaire",
		"Promessa de Cessão": "Promesse de cession",
		"Tipo desconhecido": "Type inconnu",
	},
	blockObservationPrefixes: {
		"CNPJ do solicitante:": "CNPJ du demandeur:",
	},
};
